import { Container } from '$app/shared/components/Container';
import styled from 'styled-components';

export const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const DivStyled = styled.div`
height: 100%;
margin: 0;
background: #fbfbfb;

.ant-btn-primary {
  margin-bottom: 8px;
}
`;
